import { render, staticRenderFns } from "./CollectionManageSharing.vue?vue&type=template&id=01d1da08"
import script from "./CollectionManageSharing.vue?vue&type=script&lang=js"
export * from "./CollectionManageSharing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports